import reducers from './reducers';

const landingPagesReducers = {
  landingPageReducer: reducers.landingPageReducer,
};

export { landingPagesReducers };
